import { shallowMount } from "@vue/test-utils";
import Legales from "@/components/core/Legales";

describe("Legales component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Legales);
  });

  it("Renders del component Legales", () => {
    expect(wrapper).toBeDefined();
  });
});
